import React, {useEffect, useState} from 'react';
import styles from './UnderConstruction.module.scss'
import scLogo from '../../../assets/logo-purple.png';
import underConstructionLogo from '../../../assets/under-construction.png';
import api from "../../../helpers/api";
import {setAppLoading, setUnderConstruction} from "../../../store/app-slice";
import {useDispatch} from "react-redux";

const UnderConstruction = () => {
    const dispatch = useDispatch();
    const [statusText, setStatusText] = useState(':(');

    const MS = 10000;   //test api interval in ms
    const emoticons = [
        `\t(ﾉД\`)`,
        `\t( ; ω ; )`,
        `\t(个_个)`,
        `\t(╯_╰)`,
        `\t(ノ_<、)`,
        `\t(｡•́︿•̀｡)`,
        `\t(╥_╥)`,
        `\t(╯︵╰,)`,
        `\t(｡╯︵╰｡)`,
        `\t(╥﹏╥)`,
        `\t(ﾉω･､)`,
        `\t(っ˘̩╭╮˘̩)っ`,
        `\t(ಥ﹏ಥ)`,
        `\t.･ﾟﾟ･(／ω＼)･ﾟﾟ･.`,
        `\t｡･ﾟﾟ*(>д<)*ﾟﾟ･｡`,
        `\t｡･ﾟ(ﾟ><ﾟ)ﾟ･｡`,
        `\t.｡･ﾟﾟ･(＞_＜)･ﾟﾟ･｡.`,
        `\t｡ﾟ(｡ﾉωヽ｡)ﾟ｡`,
        `\t･ﾟ･(｡>ω<｡)･ﾟ･`,
        `\t｡ﾟ･ (>﹏<) ･ﾟ｡`,
        `\t(ಡ‸ಡ)`,
        `o(〒﹏〒)o`,
        `(T_T)`,
        `\t＼(〇_ｏ)／`,
        `\t〣( ºΔº )〣`,
        `\t＼(º □ º l|l)/`,
        `\t(x_x)`,
        `(＋_＋)`,
        `\t(ﾒ﹏ﾒ)`,
        `~(>_<~)`,
        `☆⌒(> _ <)`,
    ];

    useEffect(() => {
        const interval = setInterval(async () => {
            await checkServiceStatus()
        }, MS);

        return () => clearInterval(interval);
    }, [])


    async function checkServiceStatus() {
        setStatusText('Checking...')
        try {
            let isApiAlive = await api.get('api-status');
            if (!isApiAlive || !isApiAlive.success) {
                dispatch(setUnderConstruction(true));
                dispatch(setAppLoading(false));
                return;
            }

            dispatch(setUnderConstruction(false));

        } catch (e) {
            console.error('Service is down.');
            dispatch(setUnderConstruction(true));
            dispatch(setAppLoading(false));
        } finally {
            let emoticonKey = getEmoticon();
            setStatusText(`${emoticons[emoticonKey]}`)
        }
    }

    function getEmoticon() {
        let min = 0;
        let max = emoticons.length - 1;
        return  Math.floor(Math.random() * (max - min + 1)) + min;
    }

    return (
        <div className={styles.pageContainer}>
            <div className={styles.logo}><img src={scLogo} alt={''}/></div>
            <div className={styles.container}>
                {/*<div className={styles.loader} />*/}
                <div>
                    <div className={styles.text}>Something isn't right</div>
                    <div className={styles.text2}>You can leave this page open. It will reload automatically when we're live again.</div>
                    <div><img src={underConstructionLogo} alt={''} className={styles.ucIcon}/></div>
                    <div style={{padding: '20px', height: '25px', fontWeight: '800'}}>{statusText}</div>
                </div>
            </div>
        </div>
    )
}

export default UnderConstruction;
